/**
 * Authenticated fetch using Cognito token via AWS Amplify.
 * Uses dynamic import to avoid loading Amplify at module init time.
 */
export async function signedFetch(url: string, options?: RequestInit): Promise<Response> {
  const { authenticatedFetch } = await import('./midwayAuth');
  return authenticatedFetch(url, options);
}
